import { VideoModal } from '../components/video_modal.js';

export class NodePageLandingPage extends DrupalBehavior {
  onContent(context) {
    var videoModal = new VideoModal();
    var videos = context.querySelectorAll('.article--teaser--video');
    videoModal.init(videos);
  }
}

DrupalBehavior.register('rush_theme.node_page', 'landing', NodePageLandingPage);
